var minicartQuantityHook = {

  cart: {},

  init: function() {
    this.setEvents();
  },

  setEvents: function() {
    var _self = this;

    BoosterTheme.cart.events.on(
      'booster:content:update',
      async function() {
        await _self.getCartUpdate();
        _self.updateQuantity();
      }
    );
  },

  getCartUpdate: async function() {
    var cartResponse = await fetch("/cart.js");

    this.cart = await cartResponse.json();
  },

  updateQuantity: function() {
    var itemCount = this.calculateItemCount();
    var now = new Date();

    BoosterTheme.cart.minicart.data.item_count = itemCount;
    BoosterTheme.cart.minicartHandler(now.getTime());
  },

  calculateItemCount: function() {
    var itemCount = 0;

    for(var i=0; i<this.cart.items.length; i++) {
      var item = this.cart.items[i];

        itemCount++;

    }

    return itemCount;
  }

};

function initMinicartQuantityHook() {
  if(typeof BoosterTheme == 'undefined') {
    setTimeout(initMinicartQuantityHook, 200);

    return;
  }

  minicartQuantityHook.init();
}

jQuery(document).ready(function() {
  initMinicartQuantityHook();
});